export default async function loadAsyncComponent(asyncRender) {
  if (!asyncRender.__result__) {
    asyncRender.__result__ = await asyncRender();
  }
  return asyncRender.__result__;
}



// WEBPACK FOOTER //
// ./src/components/route/route-enhance/load-async-component.js